import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

const parsed = number => {
  try {
    return phoneUtil.parseAndKeepRawInput(number || '', 'AU');
  } catch (e) {
    return number;
  }
};

const toE164 = number => {
  if (!number) return '';

  try {
    return phoneUtil.format(parsed(number), PhoneNumberFormat.E164);
  } catch (e) {
    return number;
  }
};

const fromE164 = number => {
  if (!number) return '';

  try {
    const formatted = phoneUtil.format(
      parsed(number),
      PhoneNumberFormat.NATIONAL
    );

    return formatted.replace(/ /g, '').replace('(', '').replace(')', '');
  } catch (e) {
    return number;
  }
};

const validate = number => {
  try {
    return phoneUtil.isValidNumberForRegion(parsed(number), 'AU');
  } catch (e) {
    return false;
  }
};

const isMobileNumber = number => {
  const type = phoneUtil.getNumberType(parsed(number));
  return [1, 3].includes(type);
};

const formatLS = number => {
  const cleanNumber = fromE164(number);
  try {
    const formatObj = {
      0: cleanNumber.replace(/(\d{2})(\d{4})/, '$1 $2 '),
      1: cleanNumber.replace(/(\d{4})(\d{2})/, '$1 $2 '),
      3: cleanNumber.replace(/(\d{4})(\d{2})/, '$1 $2 '),
      5:
        cleanNumber.length === 10
          ? cleanNumber.replace(/(\d{4})(\d{2})/, '$1 $2 ')
          : cleanNumber.replace(/(\d{2})/, '$1 '),
    };
    const type = phoneUtil.getNumberType(parsed(number));
    return formatObj[type] || number;
  } catch (e) {
    return number;
  }
};

const formatGeneric = number => {
  const cleanNumber = fromE164(number);
  try {
    const formatObj = {
      0: cleanNumber.replace(/(\d{2})(\d{4})(\d{4})/, '$1 $2 $3'),
      1: cleanNumber.replace(/(\d{4})(\d{3})/, '$1 $2 '),
      3: cleanNumber.replace(/(\d{4})(\d{3})/, '$1 $2 '),
      5:
        cleanNumber.length === 10
          ? cleanNumber.replace(/(\d{4})(\d{2})/, '$1 $2 ')
          : cleanNumber.replace(/(\d{2})/, '$1 '),
    };
    const type = phoneUtil.getNumberType(parsed(number));
    return formatObj[type] || number;
  } catch (e) {
    return number;
  }
};

export { toE164, fromE164, validate, formatLS, formatGeneric, isMobileNumber };
